import React, { useState, useEffect } from "react";
import { HiArrowRight } from "react-icons/hi";
import step1Image from "../../Images/new2/1.png";
import step2Image from "../../Images/new2/2.png";
import step3Image from "../../Images/new2/3.png";
import { motion, AnimatePresence } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
const Steps = () => {
  const [activeStep, setActiveStep] = useState(1);
  const handleLogoClick = (e) => {
    e.preventDefault(); // stop Link navigation
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const steps = [
    {
      id: 1,
      title: "Firmenname eingeben",
      titletext: "Ihre Reputation. Ihre Kontrolle. An jedem Standort.",
      content: `Geben Sie Ihren Unternehmensnamen ein und starten Sie den Löschprozess. Sie haben volle Kontrolle über Ihre Reputation - absolut risikofrei und mühelos.`,
      image: step1Image,
    },
    {
      id: 2,
      title: "Negative Bewertung(en) auswählen",
      titletext: "Negative Bewertung(en) auswählen",
      content: `Bewertungen auswählen. Prozess starten. Ruf verbessern.  Bestimmen Sie mit nur einem Klick, welche Bewertungen Sie melden möchten.`,
      image: step2Image,
    },
    {
      id: 3,
      title: "Prozess starten",
      titletext: "Prozess starten",
      content: `Auswahl bestätigen – der Rest läuft automatisch und mit einer beeindruckenden Erfolgsquote von über 
92%.`,
      image: step3Image,
    },
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev === steps.length ? 1 : prev + 1));
    }, 5000); // 3 seconds

    return () => clearInterval(interval);
  }, []);
  return (
    <section className=" w-full  mx-auto container-wrapper container-wrapper-whole-padding_short max-w-6xl  flex flex-col   py-4 md:py-8 font-sans">
      {/* Heading */}
      <div className="flex flex-col gap-3 mb-10 mt-10 text-center">
        <h2 className="h2-mb h2-md h2-lg h2-2xl">
          <span className="text-[#0b2b40]">So einfach funktioniert</span> <br />{" "}
          der Bewertungsmanager
        </h2>
        <p className="text-gray-500 text-sm md:text-lg ">
          Nur 3 Schritte zu mehr Sichtbarkeit, mehr Vertrauen und Umsatz
        </p>
      </div>
      <div
        className="border rounded-2xl border-black/20 mx-4 md:mx-0"
        style={{
          backgroundImage:
            "linear-gradient(180deg, hsla(240, 4%, 95%, 0.9) 50%, rgba(201, 245, 103, 0.7))",
        }}
      >
        {/* Steps Tabs */}
        <div className="">
          <div className=" w-full overflow-x-auto">
            <div className="flex md:justify-between gap-3 p-3 md:py-5 md:px-2 min-w-max">
              {steps.map((step) => (
                <button
                  key={step.id}
                  onClick={() => setActiveStep(step.id)}
                  className={`w-[300px] md:flex-1  rounded-2xl md:py-3 md:px-4 p-3 border border-black/20 flex items-center transition
              ${
                activeStep === step.id
                  ? "bg-white"
                  : "bg-gray-100/10 hover:opacity-80"
              }`}
                >
                  <div className="bg-[#0b2b40] w-12 h-12 flex items-center justify-center rounded-lg text-white font-semibold text-xl">
                    {step.id}
                  </div>
                  <div className="font-semibold text-left text-black text-lg ml-3">
                    {step.title}
                  </div>
                </button>
              ))}
            </div>
          </div>
        </div>

        {/* Active Step Content */}
        {/* Active Step Content */}
        {/* Active Step Content */}
        <div className="relative mt-11 pb-[52px] px-4 md:pl-14 overflow-hidden">
          <AnimatePresence mode="wait">
            <motion.div
              key={activeStep}
              initial={{ x: 120, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -120, opacity: 0 }}
              transition={{ duration: 0.45, ease: "easeInOut" }}
              className="flex flex-col md:flex-row gap-6 md:gap-10 items-center"
            >
              {/* Text Content */}
              <div className="flex flex-col gap-4 w-full md:w-1/2">
                <h3 className="h3-mb h3-md h3-lg h3-2xl">
                  {steps[activeStep - 1].titletext}
                </h3>

                <p className="text-black/60 text-base md:text-lg leading-relaxed">
                  {steps[activeStep - 1].content}
                </p>

                <Link className="w-fit" onClick={handleLogoClick}>
                  <button className="w-fit py-3 bg-[#0b2b40] text-white font-semibold rounded-full hover:opacity-90 transition flex gap-8 items-center justify-between px-4">
                    <span>Zum Lösch-Assistent</span>
                    <span className="bg-white text-gray-900 p-1 rounded-full flex items-center justify-center">
                      <HiArrowRight className="text-lg transform -rotate-24" />
                    </span>
                  </button>
                </Link>
              </div>

              {/* Image */}
              <div className="w-full md:w-1/2">
                <img
                  src={steps[activeStep - 1].image}
                  alt={`Step ${activeStep}`}
                  className="w-full max-h-[500px] object-cover rounded-xl"
                />
              </div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </section>
  );
};

export default Steps;
